import { Outlet } from "react-router"
import ScrollRestoration from "@/components/ScrollRestoration"

export default function RLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  )
}
